<template>
<!-- eslint-disable max-len -->
<div class="top-bar">
  <div
    class="grad-header"
    :style="gradHeaderStyle"
  >
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <h1
        v-if="$slots.default"
        class="game-title"
        :style="`${clearBackground ? 'width: 100%; text-align: center;' : ''}`"
      >
        <slot></slot>
      </h1>
    </transition>

    <div v-if="$slots.challenge" class="btn-white challenge-title" :style="titleStyle">
      <!-- <button v-if="to || next" class="btn btn-info" :tabindex="20" @click.prevent="navigate">i</button> -->
      <slot name="challenge"></slot>
    </div>

    <div v-if="showMetrics && $slots.metrics" class="btn-white metrics" :style="metricsStyle">
      <slot name="metrics"></slot>
    </div>

    <div v-if="showCash && $slots.cash" class="btn-white cash">
      <span class="currencyLabel" v-html="game.cashTopBarLabel || 'CASH RESERVE'"></span>
      <slot name="cash"></slot>
    </div>
  </div>
  <div v-if="!clearBackground" class="frame-edge"></div>

  <transition v-if="false" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <p v-if="showPlayer" class="caption player-caption">{{ playerName }}: {{ role && role.title || playerRole.title }}</p>
  </transition>

  <transition v-if="false" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <p v-if="showRightPlayer" class="caption narrator-caption">{{ playerName }}: {{ playerRole.title }}</p>
  </transition>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    to: { type: String },
    replace: { type: Boolean },
    next: { type: Function },
    showPlayer: { type: Boolean },
    showRightPlayer: { type: Boolean },
    role: { type: Object },
    clearBackground: { type: Boolean }
  },
  computed: {
    ...mapGetters([
      'playerRole',
      'me',
      'proxyAvatar',
      'teamDecision',
      'lastTeamDecision',
      'currentState',
      'resultsState',
      'complete',
      'game',
      'starfighter',
      'native'
    ]),
    playerName() {
      return (this.proxyAvatar && this.proxyAvatar.title) || this.me.firstName || this.me.email;
    },
    useLastTeamDecisionSetting() {
      return (this.currentState === this.resultsState && !this.complete);
    },
    showCash() {
      if (this.useLastTeamDecisionSetting) {
        if (this.lastTeamDecision != null) {
          return !(this.lastTeamDecision.hideCashInDashboard);
        }
        return true;
      }
      if (this.teamDecision != null) {
        return !(this.teamDecision.hideCashInDashboard);
      }
      return true;
    },
    showMetrics() {
      if (this.useLastTeamDecisionSetting) {
        if (this.lastTeamDecision != null) {
          return !(this.lastTeamDecision.hideMetricsInDashboard);
        }
        return true;
      }
      if (this.teamDecision != null) {
        return !(this.teamDecision.hideMetricsInDashboard);
      }
      return true;
    },
    gradHeaderStyle() {
      if (this.useLastTeamDecisionSetting) {
        if (this.lastTeamDecision != null && this.lastTeamDecision.topBarStyle) {
          return this.lastTeamDecision.topBarStyle;
        }
      } else if (this.teamDecision != null && this.teamDecision.topBarStyle) {
        return this.teamDecision.topBarStyle;
      }
      if (this.clearBackground) {
        return {
          'background-color': 'rgba(0, 0, 0, 0)',
        };
      } else if (this.native) {
        return ''; // TODO: different background?
      }
      return '';
    },
    metricsStyle() {
      return {
        width: (!(this.showCash)) ? '1000px' : undefined
      };
    },
    titleStyle() {
      if (this.currentState === this.resultsState && !this.complete) {
        if (this.lastTeamDecision != null && this.lastTeamDecision.topBarTitleStyle) {
          return this.lastTeamDecision.topBarTitleStyle;
        }
      } else if (this.teamDecision != null && this.teamDecision.topBarTitleStyle) {
        return this.teamDecision.topBarTitleStyle;
      }
      return (!(this.showCash || this.showMetrics))
        ? {
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          display: 'flex',
          'flex-flow': 'row nowrap',
          'justify-content': 'center',
          'align-items': 'center',
        }
        : {};
    },
  },
  methods: {
    navigate() {
      if (this.next) {
        this.next();
      } else if (this.to) {
        if (this.replace) this.$router.replace(this.to);
        else this.$router.push(this.to);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 1600px;
  height: 100px;
}
.grad-header {
  width: 100%;
  margin-bottom: 0;
  background-color: var(--topBarBackgroundColor);
  position: relative;
  height: 110px;
}
.frame-edge {
  height: 1px;
  width: 100%;
  background-color: #232323;
  margin-bottom: 0;
}
.game-title {
  color: white;
  font-size: 72px;
  padding: 15px;
  margin-right: 5px;
  text-align: right;
  width: 100%;
}
.challenge-title {
  position: absolute;
  color: white;
  width: 610px;
  height: 90px;
  left: 15px;
  top: 10px;
  font-size: 55px;
  font-weight: 600;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 0;
}
.challenge-title button {
  margin-right: 10px;
}
.cash {
  position: absolute;
  width: 300px;
  height: 90px;
  right: 0px;
  top: 10px;
  margin-right: 0;
  overflow: visible;
}
.metrics {
  position: absolute;
  // background-color: white;
  width: 730px;
  height: 90px;
  left: 560px;
  top: 10px;
  overflow: hidden;
}
.caption {
  position: absolute;
  top: 111px;
  background-color: black;
  color: var(--primaryColor);
  padding: 5px 20px;
  font-size: 22px;
  min-width: 300px;
  max-width: 350;
}
.player-caption {
  left: 0;
}
.narrator-caption {
  right: 0;
  text-align: right;
}
.currencyLabel {
  align-self: flex-end;
  display: block;
  text-align: right;
  padding-right: 18px;
  color: white;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/TopBar.vue